import Vue from 'vue';
import PrismicVue from '@prismicio/vue'

Vue.use(PrismicVue, {
  endpoint: 'https://solutionslab.cdn.prismic.io/api/v2'
})